import { render, staticRenderFns } from "./OAuthButtons.vue?vue&type=template&id=70cdbda7"
import script from "./OAuthButtons.vue?vue&type=script&lang=js"
export * from "./OAuthButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports